import Axios from 'axios'

const API = {
  options: {
    search: '/api/sitecore/press/search'
  },
  search(data) {
    return Axios.post(this.options.search, data).then((response) => {
      return response.data
    }).catch((error) => {
      console.error('API.search()', error)
    })
  }
}

export default API
